/* eslint-disable @typescript-eslint/member-ordering */
import { ElementRef, Directive, Input, OnInit, OnChanges, OnDestroy, input } from '@angular/core';

@Directive({
  selector: '[ratingsPosition]'
})
export class RatingsPositionDirective implements OnInit, OnChanges, OnDestroy {
  maxXRatingScale = input(10);
  @Input() set scale(scale: number) {
    this._scale = scale;
    this.calculatePosition();
  }

  private _scale: number;
  private resizeObserver!: ResizeObserver;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.initResizeObserver();
  }

  ngOnChanges(): void {
    if (!this.resizeObserver) {
      return;
    }
    this.resizeObserver.disconnect();
    this.initResizeObserver();
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private initResizeObserver(): void {
    this.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach(() => {
        this.calculatePosition();
      });
    });

    const someEl = document.querySelector('.question-view__q-type-container');
    this.resizeObserver.observe(someEl);
  }

  private calculatePosition(): void {
    if (this._scale > this.maxXRatingScale()) {
      (this.el.nativeElement as HTMLElement).classList.add('ratings-position--vertical');
    } else {
      (this.el.nativeElement as HTMLElement).classList.remove('ratings-position--vertical');
    }
  }
}
